import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../pages/hompage/HomePage";
import PrivateRoute from "../components/PrivateRouter";
import HomeAdmin from "../pages/Admin/HomeAdmin";
import HomeCasino from "../pages/casino/HomeCasino";
import BaccaratRoomList from "../pages/casino/LobbyCasino";
import LobbyRoom from "../pages/casino/LobbyRoom";
import CandleChart from "../pages/casino/chart/CandleChart";
import CongThucPage from "../pages/cong-thuc/CongThucPage";
import FormulaDetail from "../pages/cong-thuc/FormulaDetail";
import LoginPage from "pages/login/LoginPage";

const Approuter = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <HomePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/home"
        element={
          <PrivateRoute>
            <HomePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/casino"
        element={
          <PrivateRoute>
            <HomeCasino />
          </PrivateRoute>
        }
      />
      <Route
        path="/casino/:id"
        element={
          <PrivateRoute>
            <BaccaratRoomList />
          </PrivateRoute>
        }
      />
      <Route
        path="/casino/room/:id"
        element={
          <PrivateRoute>
            <LobbyRoom />
          </PrivateRoute>
        }
      />
      <Route
        path="/chart"
        element={
          <PrivateRoute>
            <CandleChart />
          </PrivateRoute>
        }
      />
      <Route
        path="/cong-thuc"
        element={
          <PrivateRoute>
            <CongThucPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/cong-thuc/:id"
        element={
          <PrivateRoute>
            <FormulaDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <HomeAdmin />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default Approuter;
